var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 80,
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 80,
    r: 3,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.9;0.3",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 70,
    r: 2,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "2.5s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 120,
    r: 2.5,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;1;0.4",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 180,
    r: 2,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.7;0.2",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 230,
    r: 3,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.9;0.3",
    dur: "2.2s",
    repeatCount: "indefinite"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 220,
    r: 2,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "2.8s",
    repeatCount: "indefinite"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 180,
    r: 2.5,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;1;0.4",
    dur: "2.1s",
    repeatCount: "indefinite"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 120,
    r: 2,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.6;0.2",
    dur: "2.7s",
    repeatCount: "indefinite"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 20,
    fill: "#cc0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayAttention);
export default __webpack_public_path__ + "static/media/PayAttention.df1a5bee0d85e5febeb3ea7fe26a445b.svg";
export { ForwardRef as ReactComponent };